import { usePunditUserContext } from "@/react/contexts";

export const useIsFormsV2Enabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  return Boolean(currentCommunitySettings?.cms_forms_v2_enabled);
};
